import { GeofencesService } from '../services/geofences-service';
import { RestrictedAreasModelBase } from './restricted-areas-model-impl';
import { ZoneFeature } from './zones-base-interfaces';
import { IndexedDBService } from '../../indexed-db/services/db_service';
import { isOnline } from '../utils/helpers';

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;

export class RestrictedAreasModelImpl extends RestrictedAreasModelBase {
    async getRestrictedAreas(): Promise<ZoneFeature[] | null> {
        await this.fetchZones();
        return this._areas;
    }

    constructor(geojson?: ZoneFeature[]) {
        super();

        if (geojson) {
            this._areas = geojson;
        } else {
            setInterval(() => this.fetchZones(), 60*60*1000); // refresh the list every 1h
        }
    }

    private _areas: ZoneFeature[] | null = null;

    private async fetchZones() {
        try {
            if (isVesselOnCloud && !isOnline()) {
                const cached = await IndexedDBService.zones.getByType('NAV_NOGO');
                if (cached) {
                    this._areas = cached;
                }
                return;
            }
            const areas: ZoneFeature[] = await GeofencesService.fetchGeofenceByZone('NAV_NOGO');
            if (areas) {
                this._areas = areas;
                await IndexedDBService.zones.save('NAV_NOGO', areas);
            }
        } catch (error) {
            console.warn('Failed to fetch NAV_NOGO zones from API, falling back to IndexedDB', error);
            const cached = await IndexedDBService.zones.getByType('NAV_NOGO');
            if (cached) {
                this._areas = cached;
            }
        }
    }
}
